module.exports = "/assets/6f9e7b3b0b84b609cfc8d7ad38ea3b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6D.png
// module id = 1081
// module chunks = 0